import React from "react";
import * as d3 from "d3";
import tooltip from "./tooltip";
import PropTypes from "prop-types";

export default class Bubbles extends React.Component {
  constructor(props) {
    super(props);
    const { forceStrength, center } = props;
    this.renderBubbles = this.renderBubbles.bind(this);
    this.simulation = d3
      .forceSimulation()
      .velocityDecay(0.2)
      .force("x", d3.forceX().strength(forceStrength).x(center.x))
      .force("y", d3.forceY().strength(forceStrength).y(center.y))
      .force("charge", d3.forceManyBody().strength(this.charge.bind(this)))
      .on("tick", this.ticked.bind(this))
      .stop();
  }

  state = {
    g: null,
    selected: null,
  };

  onRef = (ref) => {
    this.setState(
      {
        g: d3.select(ref),
      },
      () => this.renderBubbles()
    );
  };

  ticked = () => {
    this.state.g
      .selectAll(".bubble")
      .attr("cx", (d) => d.x)
      .attr("cy", (d) => d.y);
    this.state.g
      .selectAll(".label")
      .attr("transform", (d) => `translate(${d.x || 0}, ${d.y || 0})`);
  };

  charge = (d) => {
    let { keepPositionIntactMultiplier } = this.props,
      multiplier = Math.random() * (2.2 - 2.1) + 2.1;
    if (keepPositionIntactMultiplier) multiplier = keepPositionIntactMultiplier;

    return -this.props.forceStrength * d.radius ** multiplier;

    // return -this.props.forceStrength * d.radius ** 2.06;
  };

  onClick = (d) => {
    this.setState({ selected: d.index });
    showDetailLabelHover(d, d.index, this.state.g);
    this.props.onClickCallBack(d);
  };

  renderBubbles() {
    const bubbles = this.state.g
      .selectAll(".bubble")
      .data(this.props.data, (d) => d.id);

    bubbles.exit().remove();

    const bubblesE = bubbles
      .enter()
      .append("a")
      .attr("xlink:href", (d) => d.link)
      .append("circle")
      .classed("bubble", true)
      .attr("r", 0)
      .attr("cx", (d) => d.x)
      .attr("cy", (d) => d.y)
      .attr("fill", (d) => d.color)
      .on("mouseover", showDetail)
      .on("mouseout", hideDetail)
      .on("click", this.onClick);

    const labels = bubbles
      .enter()
      .append("text")
      .attr("dy", "-0.5em")
      .on("click", this.onClick)
      .attr("text-anchor", "middle")
      .attr("fill", findColor)
      .classed("label", true)
      .text((d) => {
        if (d.radius > 20) {
          if (d.name.length < 25) {
            return d.name.split(" ")[0];
          }
        }
      });
    bubbles
      .enter()
      .append("text")
      .on("click", this.onClick)
      .attr("dy", "0.5em")
      .attr("text-anchor", "middle")
      .attr("fill", findColor)
      .classed("label", true)
      .text((d) => {
        if (d.radius > 20) {
          if (d.name.length < 25) {
            const split = d.name.split(" ");
            if (split.length > 1) {
              return split[1];
            } else {
              return "";
            }
          }
        }
      });

    bubbles
      .enter()
      .append("text")
      .on("click", this.onClick)
      .attr("dy", "1.3em")
      .attr("text-anchor", "middle")
      .attr("fill", findColor)
      .classed("label", true)
      .text((d) => {
        if (d.radius > 20) {
          if (d.name.length < 25) {
            const split = d.name.split(" ");
            if (split.length > 2) {
              split.splice(0, 2);
              return split.join(" ");
            } else {
              return "";
            }
          }
        }
      });

    labels.transition().duration(0);
    bubblesE
      .transition()
      .duration(0)
      .attr("r", (d) => d.radius)
      .on("end", () => {
        this.simulation.nodes(this.props.data).alpha(1).restart();
      });
  }

  render() {
    return <g ref={this.onRef} className="bubbles" />;
  }
}

/*
⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠛⢻⣿⣯⣿⣿⣿⣶⣶⣶⣶⣤⣤⣤⣀⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⢨⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠈⠻⣿⡛⠉⠭⠉⠉⢉⣿⣿⣧⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠈⠙⠲⣶⠖⠄⠄⢿⣿⠄⠶⣶⣾⣿⣿⣿⣿⣧⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠈⠄⠄⠄⠺⢿⡗⠄⣹⣿⣿⠿⣟⣿⡏⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠤⠤⢾⣿⣿⣿⣦⠘⡿⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠈⢻⡿⣷⣶⣶⣤⣤⣤⣶⣦⠁⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠄⣽⣿⣿⣿⣿⣿⣿⣿⣿⡟⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠄⠘⠿⣿⣿⣿⣿⣿⣿⣿⠃⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠉⠉⠛⠋⠉⠁⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄⠄
*/
const findColor = () => {
  // if (d.color == "#F0A13A" || d.color == "#F19439") {
  //   return "black";
  // }
  return "white";
};

export function showDetail(d) {
  d3.select(this).attr("fill", d3.rgb(d.color).darker(0.5));
  if (!d.tooltip) return;
  const content = `<span class="value">${d.tooltip}</span><br/>`;
  tooltip.showTooltip(content, d3.event);
}

export function hideDetail(d) {
  d3.select(this).attr("fill", d3.rgb(d.color));
  if (!d.tooltip) return;
  tooltip.hideTooltip();
}
export function showDetailLabelHover(d, index, g) {
  let elem = g.selectAll(".bubble").filter(function (d, i) {
    return i === index;
  });
  elem.attr("fill", d3.rgb(d.color).darker(0.5));
  if (!d.tooltip) return;
  const content = `<span class="value">${d.tooltip}</span><br/>`;
  tooltip.showTooltip(content, d3.event);
}

export function hideDetailLabelHover(d) {
  if (!d.tooltip) return;
  tooltip.hideTooltip();
}

Bubbles.propTypes = {
  forceStrength: PropTypes.number,
  center: PropTypes.object,
  onClickCallBack: PropTypes.func,
  keepPositionIntactMultiplier: PropTypes.number,
  data: PropTypes.array,
};
